import React from "react";
import { Helmet } from "react-helmet-async";
import { match as Match } from "react-router-dom";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../../../utils";
import PageSubheader from "../../../../../../components/PageSubheader";
import Form from "../form";

interface Props {
  match: Match<{ id: string; reasonId: string }>;
  intl: IntlShape;
  backURL: string;
}

const UpdateIncidentReason = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.incident.reason.update.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-incident-reason-update"
        goBackURL={backURL}
      />

      <Form {...props} edition />
    </>
  );
};

export default withOneColLayout(injectIntl(UpdateIncidentReason));
